module.exports = __webpack_public_path__ + "static/media/manda-2.65aca9d9.jpg";